import styled from 'styled-components';

export const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  height: ${props => (props.transitionDisabled ? '100%' : '0')};
  visibility: ${props => (props.transitionDisabled ? 'visible' : 'hidden')};
  opacity: ${props => (props.transitionDisabled ? '100' : '0')};

  transition: 250ms;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: auto;
    margin: 16px 0;
  }
`;
